import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobMaterialId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobMaterialId`;

export const URL = (jobMaterialId: number): RouteDefinition => `${baseRoute}/${jobMaterialId}`;
